import React from 'react';
import './skeleton.css';

const Skeleton = ({
  width = '100%',
  height = '20px',
  borderRadius = '4px',
  className = '',
}) => {
  const style = {
    width,
    height,
    borderRadius,
  };

  return <div className={`wb-skeleton ${className}`} style={style} />;
};

export default Skeleton;
